import React, { useState, useEffect } from 'react'
import ParentsHeader from '../../components/Header/ParentsHeader'
import parentsbookStyle from './ParentsBook.module.css'
import BackBar from '../../components/BackBar/BackBar'
import SideBar from '../../components/Sidebar/SideBar'
import Authorimage from '../../../assets/images/9780823454143.jpg'
import { useMediaQuery } from 'react-responsive';
import { useParams, useNavigate } from "react-router-dom";
import { useCart } from '../../../context/CartContext';
require('typeface-poppins')

export default function ParentsBook() {
  const { addToCart } = useCart();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const { authorId, eventId } = useParams();
  const decodedEventId = eventId || localStorage.getItem('currentEventId');
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addedBooks, setAddedBooks] = useState({});
  const [authorDetails, setAuthorDetails] = useState(null);
  //const [books, setBooks] = useState([]);



  const handleButtonClick = (book) => {
    navigate(`/ParentsBookReview/${book.book_id}`, {
      state: {
        book: book,
        authorName: authorDetails?.author_name  // if you have it in state
      }
    });
  };

  const handleButtonCart = (book) => {
    const bookWithAuthor = {
      ...book,
      author_id: authorId  // Add the author_id to the book object
    };
    addToCart(bookWithAuthor);
    setAddedBooks(prevState => ({
      ...prevState,
      [book.book_id]: !prevState[book.book_id]
    }));
  };

  useEffect(() => {
    const fetchAuthorData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_events.php?id=${decodedEventId}`);

        if (!response.ok) {
          throw new Error('Failed to fetch event data');
        }

        const data = await response.json();
        //  console.log('API Response:', data);

        if (!data.success || !Array.isArray(data.events) || data.events.length === 0) {
          throw new Error('Invalid event data');
        }

        const event = data.events[0];

        if (!event.book_data) {
          throw new Error('No book_data found in event');
        }

        const bookData = JSON.parse(event.book_data);
        //console.log('Parsed bookData:', bookData);

        if (!Array.isArray(bookData)) {
          throw new Error('book_data is not an array');
        }

        // Find matching author
        const authorBooks = bookData.find(author =>
          Array.isArray(author.authorBookDataAdded) &&
          author.authorBookDataAdded.length > 0 &&
          String(author.authorBookDataAdded[0].author_id) === String(authorId)
        );

        if (!authorBooks) {
          // console.warn('No author matched with ID:', authorId);
          setBooks([]);
          return;
        }

        const authorDetails = authorBooks.authorBookDataAdded[0];

        const details = authorBooks.authorBookDataAdded[0];
        setAuthorDetails(details);


        if (!Array.isArray(authorDetails.books)) {
          // console.warn('No books array found for author:', authorId);
          setBooks([]);
          return;
        }

        const processedBooks = authorDetails.books.map(book => ({
          book_id: book.isbn,
          title: book.title,
          price: book.price,
          format: 'Paperback'
        }));

        // console.log('Processed books:', processedBooks);
        setBooks(processedBooks);
        localStorage.setItem('authorBooks', JSON.stringify(processedBooks));
      } catch (err) {
        console.error('Error fetching or processing author books:', err);
        setError(err.message);
        setBooks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAuthorData();
  }, [authorId, decodedEventId]);

  return (
    <>
      <ParentsHeader />
      <div className={parentsbookStyle.parentsbookPage}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            {isMobile ? (
              undefined
            ) : (
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar eventId={decodedEventId} />
              </div>
            )}
            <div className="col">
              {isMobile ? (
                // Mobile Parents Book Wrapper
                <div className={`${parentsbookStyle.mobilparentsbookWrapper} mb-4`}>
                  <h2>Books by {authorDetails ? authorDetails.author_name : 'Loading...'}</h2>
                  <div className={parentsbookStyle.mobilparentbooksCaseWrapper}>
                    {books && Array.isArray(books) && books.length > 0 ? (
                      books.map((book, index) => (
                        <div key={book.book_id} className={`${parentsbookStyle.mobilcaesBlock} d-flex`}>
                          <div className='row g-0'>
                            <div className='col-5'>
                              <div className={`${parentsbookStyle.mobilcaesimgBlock} pe-3`}>
                                <img src={Authorimage} width="600" height="840" />
                              </div>
                            </div>
                            <div className='col-7'>
                              <div className={`${parentsbookStyle.mobilcaestextBlock} h-100 d-flex justify-content-between flex-column`}>
                                <div className={parentsbookStyle.mobilparentcontentBox}>
                                  <h4>{book.title}</h4>
                                  <p>${book.price}</p>
                                </div>
                                <div className={parentsbookStyle.mobilparentaddBox}>
                                  <button
                                    className={`${parentsbookStyle.mobilparentaddButton} btn ${addedBooks[book.book_id] ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => handleButtonCart(book)}
                                  >
                                    {addedBooks[book.book_id] ? 'Added' : 'Add to Cart'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className={parentsbookStyle.mobilcaesBlock}>
                        <p>No books available</p>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                // Desktop Parents Book Wrapper
                <div className={`${parentsbookStyle.parentsbookWrapper} mb-3`}>
                  <h2>Books by {authorDetails ? authorDetails.author_name : 'Loading...'}</h2>
                  <div className={parentsbookStyle.parentbooksCaseWrapper}>
                    <ul className={`${parentsbookStyle.parentbookBoxes} ${parentsbookStyle.parentcolumnsFive} p-0`}>
                      {books && Array.isArray(books) && books.length > 0 ? (
                        books.map(book => (
                          <li className={parentsbookStyle.parentbookBoxesWrap} key={book.book_id}>
                            <div className={parentsbookStyle.parentbookcontentBlock}>
                              <div className={parentsbookStyle.parentbookblockImage} onClick={() => handleButtonClick(book)}>
                                <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/ProductImages/${book.book_id}.jpg`} width="600" height="840" />
                              </div>
                              <div className={`${parentsbookStyle.parentbookblockContent} mt-1`}>
                                <h5 className='text-start' onClick={() => handleButtonClick(book)}>{book.title}</h5>
                                <div className="d-flex justify-content-between flex-wrap">
                                  <p className={`${parentsbookStyle.parentpaperBook} text-start`}>{book.format}</p>
                                  <span className={parentsbookStyle.parentbookPrice}>${book.price}</span>
                                </div>
                                <div className={`${parentsbookStyle.parentbookblockbtn} mt-3`}>
                                  <button className={`btn ${addedBooks[book.book_id] ? 'btn-danger' : 'btn-success'} 
                                    ${addedBooks[book.book_id] ? parentsbookStyle.parentremoveButton : parentsbookStyle.parentaddButton} w-100`}
                                    onClick={() => handleButtonCart(book)}>
                                    {addedBooks[book.book_id] ? 'Added' : 'Add to Cart'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className={parentsbookStyle.parentbookBoxesWrap}>
                          <div className={parentsbookStyle.parentbookcontentBlock}>
                            <span>No Books available</span>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
